import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { LanguageService } from './language.service'

/**
 * Adds `x-trendmulti-language: {currentLang}` to every outbound API request so
 * the backend resolves the same effective language the UI is showing (RF-04,
 * RF-05). Asset requests (translation catalogs) bypass this — they are loaded
 * through a separate HttpBackend client.
 */
@Injectable()
export class LanguageHeaderInterceptor implements HttpInterceptor {
  constructor(private readonly languageService: LanguageService) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const cloned = req.clone({
      setHeaders: { 'x-trendmulti-language': this.languageService.currentLang },
    })
    return next.handle(cloned)
  }
}
